export default __webpack_public_path__ + "src/modules/AuthModule/images/bg/bg-image-left.svg";